import { Intent, OverlayToaster, Position } from '@blueprintjs/core'

const toaster = OverlayToaster.create({
  className: 'recipe-toaster',
  position: Position.TOP
})

export default function showSuccess(message: string, intent: Intent = Intent.SUCCESS): void {
  window.scrollTo(0, 0)
  toaster.show({ message, intent, timeout: 1500 })
}
